import SignUpByEmail from 'components/modals/v2/auth/sign_up_by_email_modal/sign_up_by_email_modal';
export default SignUpByEmail;
